import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-panel"},[_c(VTabs,{attrs:{"value":_vm.value,"background-color":"transparent"},on:{"change":_vm.handleTabChange}},_vm._l((_vm.tabs),function(ref){
var id = ref.id;
var name = ref.name;
return _c(VTab,{key:id,staticClass:"tab"},[_vm._v(" "+_vm._s(name)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }